/* eslint-disable react/no-string-refs */
import React, { Component } from 'react'
import pqgrid from 'pqgridf'
import 'jquery-ui-pack/jquery-ui.css'
import 'jquery-ui-pack/jquery-ui.structure.css'
import 'jquery-ui-pack/jquery-ui.theme.css'
import 'pqgridf/pqgrid.min.css'
import 'pqgridf/pqgrid.ui.min.css'
import 'pqgridf/themes/steelblue/pqgrid.css'
import 'pqgridf/localize/pq-localize-pt_br'

export default class Pqgrid extends Component {
  constructor(props) {
    super(props)
    this.state = {}

    this.grid = null
  }

  componentDidMount() {
    const { colModel, numberCell, title } = this.props

    /* const colM = [
      {
        title: 'Ship Country',
        dataIndx: 'ShipCountry',
        width: 120,
        cls: 'pq-dropdown pq-side-icon',
        editor: {
          type: 'textbox',
        },
        validations: [
          { type: 'minLen', value: 1, msg: 'Required' },
        ],
      },
      {
        title: 'Books',
        dataIndx: 'books',
        width: 90,
        cls: 'pq-dropdown pq-side-icon',
        editor: {
          type: 'textbox',
          init: autoCompleteEditor(books),
        },
        validations: [
          { type: 'minLen', value: 1, msg: 'Required' },
          {
            type(ui) {
              const { value } = ui
              if ($.inArray(ui.value, books) == -1) {
                ui.msg = `${value} not found in list`
                return false
              }
            },
            icon: 'ui-icon-info',
          },
        ],
      },
      {
        title: 'Fruits',
        dataIndx: 'fruits',
        width: 140,
        // custom editor.
        editor: {
          options: ['Apple', 'Orange', 'Kiwi', 'Guava', 'Grapes'],
          type(ui) {
            // debugger;
            const { options } = ui.column.editor
            const str = options.map((option) => {
              const checked = (option == ui.cellData) ? 'checked = checked' : ''
              return `<input type='radio' ${checked} name='${ui.dataIndx}' style='margin-left:5px;' value='${option}'>  ${option}`
            }).join('')

            ui.$cell.append(`<div class='pq-editor-focus' tabindex='0' style='padding:5px;margin-top:1px;'>${str}</div>`)
          },
          getData(ui) {
            return ui.$cell.find('input:checked').val()
          },
        },
      },
      {
        title: 'Order ID',
        width: 100,
        dataIndx: 'OrderID',
        editor: {
          type: 'textbox',
          // make it html5 number editor.
          attr: "type='number'",
        },
      },
      {
        title: 'Order Date',
        width: '120',
        dataIndx: 'OrderDate',
        dataType: 'date',
        format: 'yy-mm-dd',
        cls: 'pq-calendar pq-side-icon',
        editor: {
          type: 'textbox',
          init: dateEditor,
          getData(ui) {
            // convert from column format to native js date format "mm/dd/yy"
            const dt = $.datepicker.parseDate(ui.column.format, ui.$cell.find('input').val())
            return $.datepicker.formatDate('mm/dd/yy', dt)
          },
        },
        validations: [
          { type: 'regexp', value: '^[0-9]{2}/[0-9]{2}/[0-9]{4}$', msg: 'Not in date format' },
        ],
      },
      { dataIndx: 'ShipViaId', hidden: true }, // hidden column to store ShipVia Id.
      {
        title: 'Shipping Via',
        dataIndx: 'ShipVia',
        width: 110,
        cls: 'pq-dropdown pq-side-icon',
        editor: {
          type: 'select',
          init(ui) {
            ui.$cell.find('select').pqSelect()
            setTimeout(() => {
              ui.$cell.find('select').pqSelect('open')
            })
          },
          valueIndx: 'value',
          labelIndx: 'text',
          mapIndices: { text: 'ShipVia', value: 'ShipViaId' },
          options: [
            { value: '', text: '' },
            { value: 'SE', text: 'Speedy Express' },
            { value: 'UP', text: 'United Package' },
            { value: 'FS', text: 'Federal Shipping' },
          ],
        },
        validations: [{ type: 'minLen', value: 1, msg: 'Required' }],
      },
      {
        title: 'Freight',
        dataIndx: 'Freight',
        dataType: 'float',
        width: 100,
        format: '$#,###.00',
        editor: { select: true },
        validations: [{ type: 'gte', value: 1, msg: 'should be >= 1' }],
        editModel: { keyUpDown: true },
      },
      {
        title: 'Shipping Address',
        width: 200,
        dataIndx: 'ShipAddress',
        editor: {
          type: 'textarea',
        },
        editModel: {
          saveKey: '', // disable or set it to some other key code to free up use of Enter key for line breaks.
        },
        validations: [{ type: 'minLen', value: 1, msg: 'Required' }],
      },
    ] */

    this.grid = pqgrid.grid(this.refs.grid, {
      title,
      colModel,
      numberCell,
      cellEdit: true,
      showTitle: true,
      reactive: true,
      locale: 'pt_br',
      height: 'flex',
      strNoRows: 'Sem registros.',
      scrollModel: {
        autoFit: true,
      },
      animModel: {
        on: true,
      },
      pageModel: {
        type: 'local',
        rPP: 5,
        rPPOptions: [5, 10, 50, 100],
        layout: ['strDisplay', '|', 'prev', 'next'],
      },
      dataModel: {
        data: [],
      },
      toolbar: {
        items: [
          {
            type: 'button',
            label: 'Novo item',
            listener: () => this.addRow(),
          },
          {
            type: 'button',
            label: 'Excluir item',
            listener: () => this.deleteRow(),
          },
        ],
      },
    })
  }

  addRow = () => {
    const rowData = {}
    const rowIndx = this.grid.addRow({ rowData, checkEditable: false })
    this.grid.focus({ rowIndxPage: rowIndx, colIndx: 0 })
  }

  deleteRow = () => {
    const selection = this.grid.selection().address()
    console.tron.log('selection', selection)

    if (selection[0]?.type === 'row') {
      this.grid.deleteRow({ rowIndx: selection[0].r1 })
    }
  }

  render() {
    return <div ref="grid" />
  }
}
